<ng-container *ngIf="data">
    <div class="lottie-bg-item" *ngFor="let item of data">
        @defer {
            <finder-lottie
                [data]="item"
                [playback]="triggerPlayback"
            ></finder-lottie>
        }
    </div>
</ng-container>
